import { SearchTab } from '@habity/types';

/**
 * Updates the tab parameter in the URL while preserving all other search parameters.
 * Uses router.replace to avoid adding to browser history.
 * 
 * @param tab - The new tab to navigate to
 * @param pathname - Current pathname from usePathname()
 * @param searchParams - Current search params from useSearchParams()
 * @param router - Router instance from useRouter()
 * @param additionalParams - Optional additional parameters to add/update in the URL
 */
export const updateTabParam = (
  tab: SearchTab,
  pathname: string | null,
  searchParams: URLSearchParams | null,
  router: { replace: (url: string, options?: { scroll?: boolean }) => void },
  additionalParams?: Record<string, string>
) => {
  if (!pathname) return;

  // Create new URLSearchParams from existing params
  const params = new URLSearchParams(searchParams?.toString() || '');
  
  // Set the tab
  params.set('tab', tab);
  
  // Add any additional parameters
  if (additionalParams) {
    Object.entries(additionalParams).forEach(([key, value]) => {
      params.set(key, value);
    });
  }
  
  router.replace(`${pathname}?${params.toString()}`, { scroll: false });
};
